import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { PartnumberNaoOriginalComponent } from './partnumber-nao-original.component';
import { PartnumberNaoOriginalService } from './partnumber-nao-original.service';

@NgModule({
  imports: [
    ComumModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    TooltipModule,
    InputTextModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    PartnumberNaoOriginalComponent
  ],
  declarations: [
    PartnumberNaoOriginalComponent
  ],
  providers: [
    PartnumberNaoOriginalService
  ]
})
export class PartnumberNaoOriginalModule { }